import { TContentListOrder } from '@_entities/content';

export const CONTENT_QUERY_KEYS = {
	contentList: (folderId: string, order?: TContentListOrder, keyword?: string) => [
		'contentList',
		{
			folderId,
			order,
			keyword,
		},
	],
};
